module.exports = __webpack_public_path__ + "media/assets/images/instagram-logo-black-4d969dd141d389ed7a2fe7584b56d681.svg";